export default __webpack_public_path__ + "static/media/instant_messaging.b27181e9.svg";